<template>
  <div>
    <ul class="sidebar-menu">
      <template v-for="(item, itemIdx) in localMenu">
        <!-- Item WITH children (collapsible) -->
        <template v-if="item.children && item.children.length">
          <li :key="`smi-collapse-${itemIdx}`" :class="{ open: item.open }" class="sidebar-menu-item">
            <span v-b-toggle="`sm-${_uid}-${itemIdx}`" class="sidebar-menu-button" @click.prevent>
              <i class="material-icons sidebar-menu-icon sidebar-menu-icon--left">{{ item.icon }}</i>
              {{ item.label }}
              <span class="ml-auto sidebar-menu-toggle-icon" />
            </span>
            <b-collapse
              :id="`sm-${_uid}-${itemIdx}`"
              v-model="item.open"
              class="sidebar-submenu sm-indent"
              tag="ul"
            >
              <li
                v-for="child in item.children"
                :key="child.route.name"
                class="sidebar-menu-item"
                :class="{ active: child.active }"
              >
                <router-link :to="child.route" class="sidebar-menu-button clickable-item">
                  <span class="sidebar-menu-text">{{ child.label }}</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
        </template>
        <!-- Item WITHOUT children -->
        <template v-else>
          <li :key="`smi-${itemIdx}`" class="sidebar-menu-item" :class="{ active: item.active }">
            <router-link :to="item.route" class="sidebar-menu-button clickable-item">
              <i class="material-icons sidebar-menu-icon sidebar-menu-icon--left">{{ item.icon }}</i>
              <span class="sidebar-menu-text">{{ item.label }}</span>
            </router-link>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SidebarMenu',
  props: {
    menu: { type: Array, default: () => [] },
  },
  data() {
    return {
      localMenu: [],
    };
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.updateLocalMenu();
      },
    },
    menu: {
      deep: true,
      handler() {
        this.updateLocalMenu();
      },
    },
  },
  mounted() {
    this.updateLocalMenu();
  },
  methods: {
    updateLocalMenu() {
      if (!Array.isArray(this.menu) || !this.menu.length) {
        this.localMenu = [];
        return;
      }
      this.localMenu = this.menu.map(item => {
        const childRouteNames = (item.children || []).map(c => c.route?.name).filter(Boolean);
        const childRouteHrefs = childRouteNames.map(name => {
          try {
            return this.$router.resolve({ name }).href;
          } catch {
            return null;
          }
        }).filter(Boolean);

        return {
          ...item,
          children: (item.children || []).map(child => ({
            ...child,
            active:
              child.route?.name === this.$route.name ||
              (child.route?.name && this.$route.path.startsWith(
                this.$router.resolve({ name: child.route.name }).href
              )),
          })),
          open:
            childRouteNames.includes(this.$route.name) ||
            !!childRouteHrefs.find(href => this.$route.path.startsWith(href)),
          active:
            !item.children?.length && (
              item.route?.name === this.$route.name ||
              (item.route?.name && (() => {
                const href = this.$router.resolve({ name: item.route.name }).href;
                return href !== '/' && this.$route.path.startsWith(href);
              })())
            ),
        };
      });
    },
  },
};
</script>
